import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import { getActionsApiBaseUrl } from '@/microApps/kit';
import buildAdminMicroAppsPath from '../helpers/buildAdminMicroAppsPath';
import buildAdminMicroAppsQueryKey from '../helpers/buildAdminMicroAppsQueryKey';
import type {
    AdminMicroAppsListEnvelope,
    UseListAdminMicroAppsParams,
    UseListAdminMicroAppsResult,
} from '../types';

const useListAdminMicroApps = ({
    isQueryEnabled,
}: UseListAdminMicroAppsParams): UseListAdminMicroAppsResult => {
    const { data, isLoading, error, refetch } = useHttpQuery<AdminMicroAppsListEnvelope>({
        pathname: buildAdminMicroAppsPath(),
        method: 'GET',
        server: getActionsApiBaseUrl(),
        key: buildAdminMicroAppsQueryKey(),
        queryOptions: {
            enabled: isQueryEnabled,
        },
    });

    return {
        microApps: data?.data.microApps ?? [],
        isLoadingMicroApps: isLoading,
        error: error || undefined,
        refetch,
    };
};

export default useListAdminMicroApps;
